import React from "react";
import { Container } from "react-bootstrap";

import ApiCallCard from "./ApiCallCard/ApiCallCard";
import ApiParametersCard from "./ApiParametersCard/ApiParametersCard";
import ApiResponseCard from "./ApiResponseCard/ApiResponseCard";

import "./ApiView.css";

const ApiView = (props) => {
	return (
		<Container>
			<ApiCallCard provider={props.provider} />
			<ApiParametersCard provider={props.provider} />
			<ApiResponseCard provider={props.provider} />
		</Container>
	);
};

export default ApiView;